import { type Moment } from "moment";
import { type RouteComponentProps } from "react-router";

import { type MenuItemName } from "types/enum";

export interface IHeaderAlertExtraData {
    alertDate?: Moment;
    integration?: string;
    linkText?: string;
    url?: string;
}

export enum AlertType {
    Subscription = 0,
    Maintenance = 1,
    Accounting = 2,
    GeneralWarning = 3,
    MFAWarning = 4,
    LeadEmailOverage = 5,
}

export interface IBannerAlertProps<ExtraDataType = IHeaderAlertExtraData>
    extends RouteComponentProps {
    alert: IAlert<ExtraDataType>;
    selectedMenuItem?: MenuItemName;
}

export class IAlert<ExtraDataType> {
    alertTitle: string;
    alertText: string;
    redirectText: string;
    alertType: AlertType;
    extraData?: ExtraDataType;
}
